import { Visibility } from '@mui/icons-material';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import React from 'react';
import { ResourceLink } from '../../reusable/ResourceLink';
import ClipboardField from '../components/ClipboardField';

export interface SalesDemoMember {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

interface ClientMembersListProps {
  members: SalesDemoMember[];
}

// Table of the predefined demo members for a client. The name links to the
// member's admin profile (new tab); the email is whole-text click-to-copy.
export const ClientMembersList: React.FC<ClientMembersListProps> = ({
  members,
}) => (
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell>First and Last Name</TableCell>
        <TableCell>Email</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {members.map((member) => (
        <TableRow key={member.id}>
          <TableCell>
            <Tooltip title="Open admin profile in a new tab">
              <span>
                <ResourceLink
                  name="User"
                  id={member.id}
                  type="show"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Box
                    component="span"
                    display="inline-flex"
                    alignItems="center"
                    gap={0.5}
                  >
                    <Visibility fontSize="small" />
                    {member.firstName} {member.lastName}
                  </Box>
                </ResourceLink>
              </span>
            </Tooltip>
          </TableCell>
          <TableCell>
            {member.email ? (
              <ClipboardField record={member} source="email" />
            ) : null}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
